import { createTheme } from '@material-ui/core/styles'

const theme = createTheme({
  palette: {
    success: {
      main: '#4caf50',
    },
    info: {
      main: '#2196f3',
    },
    warning: {
      main: '#ff9800',
    },
    error: {
      main: '#f44336',
    },
  },
})
export default theme
